import React, { useContext, useEffect, useState, useMemo } from "react";
import { Button, Modal } from 'react-bootstrap';
import { toast } from "react-toastify";
import http from "../Services/httpService";
import services from "../Services/noronServices";
import UserAccount from './UserAccount'
export default function UserAccounts({ show, handleClose, devices }) {
  const [list, setList] = useState([]);
  const [listMaster, setListMaster] = useState([]);
  useEffect(() => {
    if (show)
      UserAccountList()
  }, [show])

  const [search, setSearch] = useState("");
  useEffect(() => {
    if (listMaster && search != "") {
      setList(listMaster.filter(x => x.displayName.includes(search) || ("nationalCode" in x && x.nationalCode.includes(search))))
      return;
    }
    setList(listMaster);
  }, [listMaster, search])

  const [isloadUserAccountList, setIsloadUserAccountList] = useState(false)
  const UserAccountList = async () => {
    setIsloadUserAccountList(true);
    await services.UserAccountList()
      .then(({ data }) => {
        setIsloadUserAccountList(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        setListMaster(data.payload);
      })
      .catch(err => {
        setIsloadUserAccountList(false);
      });
  }

  const [form, setForm] = useState(services.defaultUserAccount);
  const doEdit = async (e, item, index) => {
    e.preventDefault();
    const temp = [...list];
    temp[index].isEditing = true;
    setList(temp);
    await services.UserAccountGet(item.subUserId)
      .then(({ data }) => {
        const temp = [...list];
        temp[index].isEditing = false;
        setList(temp);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        setForm(data.payload);
        setShowNewUserAccount(true)
      })
      .catch(err => {
        const temp = [...list];
        temp[index].isEditing = false;
        setList(temp);
      });
  }

  const doDelete = async (e, item, index) => {
    e.preventDefault();
    const temp = [...list];
    temp[index].isDeleteing = true;
    setList(temp);
    await services.UserAccountDelete(item.subUserId)
      .then(async ({ data }) => {
        const temp = [...list];
        temp[index].isDeleteing = false;
        setList(temp);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        await UserAccountList();
      })
      .catch(err => {
        const temp = [...list];
        temp[index].isDeleteing = false;
        setList(temp);
      });


  }

  const [showNewUserAccount, setShowNewUserAccount] = useState(false)
  return (
    <>
      <UserAccount
        show={showNewUserAccount}
        data={form}
        handleClose={async (e) => {
          setShowNewUserAccount(false);
          await UserAccountList();
        }}
        devices={devices} />

      <Modal show={show} onHide={handleClose} centered size="lg" scrollable>
        <Modal.Header closeButton>
          <Modal.Title className="">کاربران زیر مجموعه شما</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="row">
            <div className="col">
              <button
                className="btn btn-primary"
                onClick={() => {
                  setForm(services.defaultUserAccount);
                  setShowNewUserAccount(true)
                }
                }
              >جدید</button>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <div className="input-group mb-3">
                <input
                  className="form-control"
                  placeholder="جستجو"
                  value={search}
                  name="search"
                  onChange={e => setSearch(e.target.value)}
                />
                <span className="input-group-text" id="basic-addon1">
                  {isloadUserAccountList &&
                    <div className=" spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  }
                </span>
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col">
              {list.map((item, index) =>
                <div className="row border rounded p-3 mt-3" key={index + "accountUser"}>
                  <div className="col">
                    {item.displayName}   {/*item.nationalCode*/}
                  </div>
                  <div className="col-auto">
                    <div className="btn-group">
                      <button
                        className="btn btn-primary"
                        onClick={e => doEdit(e, item, index)}
                        disabled={item.isEditing || item.isDeleteing}
                      >
                        ویرایش
                        {item.isEditing &&
                          <div className=" spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        }
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={e => doDelete(e, item, index)}
                        disabled={item.isEditing || item.isDeleteing}
                      >
                        حذف
                        {item.isDeleteing &&
                          <div className=" spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        }
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal >
    </>
  )
}

